import { Drawer } from "@mui/material";

import useIsMobile from "../../hooks/useIsMobile";

const DrawerDialog = ({ open, onClose, children, slotProps, minWidth = "30rem", styles, ...props }) => {
  const { isMobile } = useIsMobile();
  return (
    <Drawer anchor="right" open={open} onClose={onClose} {...props} variant="temporary" slotProps={{ paper: {sx: {
      height: "99.4%",
      p: ".5rem",
      borderRadius: "10px",
      minWidth: isMobile ? "100%" : minWidth,
      top: ".3%",
      bottom: ".3%",
      // transform: "translateY(-50%) !important",
      overflowX: "hidden",
      ...styles
    }}, ...slotProps}}>
      {children}
    </Drawer>
  );
};

export default DrawerDialog;